import React from 'react';

export default function CookiePage() {
  return (
    <div style={{
      maxWidth: 800,
      margin: '0 auto',
      padding: '40px 24px 80px',
      fontFamily: "'Inter', sans-serif",
      color: '#0d0d0b',
      lineHeight: 1.7,
    }}>
      <h1 style={{
        fontFamily: "'Fraunces', serif",
        fontSize: 32,
        fontWeight: 500,
        marginBottom: 8,
        color: '#0d0d0b',
      }}>
        Політика використання cookie
      </h1>
      <p style={{ color: '#6b6560', fontSize: 14, marginBottom: 40 }}>
        Ресторан «Околиця» — okolitsya-lentochka.com.ua
      </p>

      <section style={{ marginBottom: 24 }}>
        <p style={pStyle}>При перегляді нашого веб-сайту інформація може зберігатися у файлах «Cookie», встановлених нами або третіми особами на вашому смартфоні, планшеті або комп'ютері.</p>
      </section>

      <section style={{ marginBottom: 24 }}>
        <p style={pStyle}>Цей інформаційний документ інформує про використання файлів cookie, пов'язаних із програмним забезпеченням браузера вашого смартфона, планшета або комп'ютера. Ця сторінка дозволяє зрозуміти, що таке cookie-файли, як ми їх використовуємо та які засоби у вашому розпорядженні для блокування цих cookie-файлів.</p>
      </section>

      <section style={{ marginBottom: 24 }}>
        <p style={pStyle}><strong>Файли cookie</strong> — це невеликі текстові файли, що зберігаються на вашому пристрої (браузері) при відвідуванні різних сайтів. Файли cookie використовуються для забезпечення або підвищення працездатності сайтів. Також їх використовують для отримання інформації аналітичного характеру, наприклад, вподобання користувача на сайті, такі як місце перебування, мова тощо.</p>
      </section>

      <section style={{ marginBottom: 24 }}>
        <p style={pStyle}>Ви можете відмовитись від використання файлів cookie за допомогою браузера. Браузери можуть бути налаштовані так, щоб файли cookie створювалися лише за попередньою згодою або відхилялися.</p>
      </section>

      <section style={{ marginBottom: 24 }}>
        <p style={pStyle}>Ми можемо вносити зміни на даній інформаційній сторінці по мірі необхідності, що стосуються використовування файлів cookie, або у зв'язку зі зміною правил, що відносяться до файлів cookie.</p>
      </section>

      <section style={{
        marginTop: 40,
        padding: '20px 28px',
        background: '#f9f6f1',
        borderRadius: 16,
        border: '1px solid #e8ddd0',
        fontSize: 14,
        color: '#6b6560',
      }}>
        <strong style={{ color: '#0d0d0b' }}>Контакти:</strong><br />
        ФОП Візнюк Олена Василівна<br />
        Телефон: +380 (96) 736-51-96<br />
        Сайт: okolitsya-lentochka.com.ua
      </section>
    </div>
  );
}

const pStyle = {
  marginBottom: 0,
  color: '#0d0d0b',
  fontSize: 15,
};
